import Text from 'Components/Atoms/Text/Text';
import Title from 'Components/Atoms/Title/Title';
import TitleGroup from 'Components/Molecules/TitleGroup/TitleGroup';
import { Helmet } from 'react-helmet-async';
import { ROUTES } from 'Services/Route/Route.types';
import PageTemplate from '../Page/PageTemplate';
import styles from './UserTemplate.module.sass';

const UserTemplate = ({
      children,
      breadcrumbs, description
  }: any) => {
    return <PageTemplate>
        <Helmet>
            <title>{ ROUTES.SETTINGS.title }</title>
        </Helmet>
        <div className={styles['usertemplate']}>
            <div className={styles['usertemplate__header']}>
                <TitleGroup>
                    { breadcrumbs || <Title size='small' weight='semibold'>Jouw profiel</Title> }
                    {/*<Text color='secondary'>{ description || "Selecteer een instellingscategorie"}</Text>*/}
                </TitleGroup>
            </div>
            <div className={styles['usertemplate__content']}>
                { children }
            </div>
        </div>
    </PageTemplate>
}

export default UserTemplate;